import { useStores } from 'hooks';
import { observer } from 'mobx-react-lite';
import React from 'react';
import styled from 'styled-components';
// import { simLogTooLarge } from '../../../../../shared/utils/SimulcastLogger';
import { Badge, GREEN, Message, RED, Row, TimeStamp, getColor } from '../Styles';
import { collapsedData } from './../utils';

export const CollapsedView = observer(() => {
  const {
    AuctionStore: { connected, networkConnected },
    DebuggerStore: { getLog, simLogTooLarge },
  } = useStores();


  // const logTooBig = simLogTooLarge();
  const logTooBig = simLogTooLarge;

  const isConnected = connected && networkConnected;
  const connectedColor = isConnected ? GREEN : RED;

  const log = getLog({ target: 'ui' });
  const collapsed = collapsedData(log);
  
  return (
    <>
      {collapsed.keys.map((item, index) => {
        const { data } = collapsed;
        const { message, messageType, timestamp } = data[item][0];
        const { bgColor, color } = getColor(messageType);
        const shouldFlash = logTooBig ? false : index === 0;
        const messageCount = data[item].length;
        return (
          <Row
            flashColor={connectedColor}
            key={`${timestamp}; log-index=${index}`}
            latestMessage={shouldFlash}
          >
            <TimeStamp bgColor={bgColor} color={color}>
              <div>{timestamp}</div>
              <StyledBadge bgColor={color} color={bgColor}>
                {messageCount}
              </StyledBadge>
            </TimeStamp>
            <Message>{message}</Message>
          </Row>
        );
      })}
    </>
  );
});

export default CollapsedView;

const StyledBadge = styled(Badge)`
  font-size: 0.8em;
`;